module.exports = __webpack_public_path__ + "img/rt-logo.05bd546b.png";